<template>
    <LeaveRequestList :activeTabIndex="2" title="Rejected" extraRouteQuery="approved=false" />
</template>

<script>
import LeaveRequestList from "./leave-request-list.vue"
export default { components: { LeaveRequestList } }
</script>
